import { Badge, Group, Stack, Text, Timeline } from '@mantine/core';
import type { ClaimTimelineEvent } from '../mockClaims';
import { formatDateTime } from './billingFormatters';

const OUTCOME_COLORS: Record<ClaimTimelineEvent['outcome'], string> = {
  complete: 'green',
  error: 'red',
  pending: 'gray',
};

export function ClaimTimeline({ events }: { events: ClaimTimelineEvent[] }): JSX.Element {
  return (
    <Stack gap="xs">
      <Text size="xs" c="dimmed" tt="uppercase" fw={600}>
        Claim Lifecycle
      </Text>
      <Timeline active={events.length - 1} bulletSize={22} lineWidth={2}>
        {events.map((event) => (
          <Timeline.Item
            key={`${event.label}-${event.at}`}
            title={
              <Group gap="xs">
                <Text size="sm" fw={600}>
                  {event.label}
                </Text>
                <Badge variant="light" size="xs" color={OUTCOME_COLORS[event.outcome]}>
                  {event.outcome}
                </Badge>
              </Group>
            }
          >
            <Text size="xs" c="dimmed">
              {formatDateTime(event.at)}
            </Text>
            {event.detail && (
              <Text size="sm" mt={4}>
                {event.detail}
              </Text>
            )}
          </Timeline.Item>
        ))}
      </Timeline>
    </Stack>
  );
}
